module.exports = __webpack_public_path__ + "static/media/releases.cde459ec.jpg";